import React from 'react';

import Section from '../uic/Section';
import { List } from '../uic/list';
import ValueRow from '../uic/ValueRow';
import session from '../session';

class LicenseStatus extends React.Component {
    state = {
        disabled: true
    };

    async componentDidMount() {
        const res = await session.rpc('call', [
            '',
            'uci',
            'get',
            {
                config: 'icecast',
                section: 'relay'
            }
        ]);
        const {
            disabled,
            server,
            local_mount,
            port,

            relay_shoutcast_metadata,
            remote_mount
        } = res[1].values;

        this.setState({
            disabled: disabled === '1',
            server,
            local_mount,
            port,

            relay_shoutcast_metadata,
            remote_mount
        });
    }

    render() {
        const {
            disabled,
            server,
            local_mount,
            port,
            relay_shoutcast_metadata,
            remote_mount
        } = this.state;

        if (disabled) {
            return null;
        }

        return (
            <Section title="Icecast Relay">
                <List>
                    <ValueRow
                        label="Remote Stream"
                        value={`http://${server}:${port}${remote_mount}`}
                    />
                    <ValueRow
                        label="Local Mount"
                        value={`http://${
                            window.location.hostname
                        }:8000${local_mount}`}
                    />
                    <ValueRow
                        label="Relay Shoutcast Metadata"
                        value={relay_shoutcast_metadata === '0' ? 'No' : 'Yes'}
                    />
                </List>
            </Section>
        );
    }
}

export default LicenseStatus;



// WEBPACK FOOTER //
// ./src/sections/IcecastRelay.js